import { setHours, setMinutes } from 'date-fns';
import type { DutyCodePeriodRequest } from 'generated';
import { chunk } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import { type TimePeriod, toLocalISOString } from 'utils/date';

type CreatePeriodsProps = {
  periodStartDate: Date;
  timePeriods: TimePeriod[];
  dutyHourTypeId?: number;
  tempId?: string;
};

type DutyCodePeriod = DutyCodePeriodRequest & {
  tempId?: string;
};

export const createPeriods = ({
  periodStartDate,
  timePeriods,
  dutyHourTypeId,
  tempId
}: CreatePeriodsProps) =>
  chunk(timePeriods, 2).map(
    (interval) =>
      ({
        startTime: toLocalISOString(
          setHours(
            setMinutes(
              periodStartDate,
              parseInt(interval[0].split(':')[1], 10)
            ),
            parseInt(interval[0].split(':')[0], 10)
          )
        ),

        endTime: toLocalISOString(
          setHours(
            setMinutes(
              periodStartDate,
              parseInt(interval[1].split(':')[1], 10)
            ),
            parseInt(interval[1].split(':')[0], 10)
          )
        ),

        tempId: tempId || uuidv4(),
        dutyHourTypeId: dutyHourTypeId
      }) as DutyCodePeriod
  );
